<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      height="800px"
      content-class="overflow-hidden"
      transition="dialog-transition"
      :fullscreen="$vuetify.breakpoint.name == 'xs'"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>Charts <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <v-btn 
            :disabled="loading"
            outlined
            @click="hideChart"
            class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
            :x-large="$vuetify.breakpoint.name == 'xl'"
            :large="$vuetify.breakpoint.name == 'lg'"
          >
            <v-icon color="white">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row class="d-flex justify-space-around" v-if="!isHideInputs">
                <!---->
                <v-col class="col-6">
                  <v-dialog
                    ref="dialogDateEnd"
                    v-model="dateChart.isShowDateEnd"
                    :return-value.sync="dateChart.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mt-4 ml-xl-2 ml-lg-2 ml-md-2  ml-sm-2  ml-xs-2"
                        outlined
                        v-model="dateChart.date"
                        label="Date End"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateChart.date"
                      header-color="white"
                      flat
                      type="date"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="dateChart.isShowDateEnd = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialogDateEnd.save(dateChart.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <!---->
                <v-col class="col-6">
                  <v-select
                    class="mt-4 ml-xl-2 ml-lg-2 ml-md-2  ml-sm-2  ml-xs-2"
                    :disabled="loading"
                    outlined
                    v-model="selectedSensorType"
                    :items="selectedDeviceSensors"
                    item-text="sensorName"
                    item-value="sensorTypeId"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Param"
                    persistent-hint
                    dense
                    hide-details
                    v-on:change="updateParam"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="col-12">
                  <Plotly :data="data" :layout="layout" :display-mode-bar="false" :scrollZoom="true"></Plotly>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="col-12 d-flex justify-end">
              <v-btn :disabled="loading" depressed outlined 
                class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'"
                @click="loadCharts">
                Load Chart
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { Plotly } from 'vue-plotly'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog', 'device'],
    name: 'Charts',
    data(){
      return {
        isHideInputs: false,
        dateChart:{
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          isShowDateEnd: false
        },
        loading: false,
        selectedDevice: null,
        selectedDeviceSensors: [],
        selectedSensorType: null,
        data:[],
        layout:{
          type: 'scattergl',
          showlegend: true,
          width: '100%',
          height: '100%',
          legend: {
            x: 0,
            y: 1.2,
            orientation: "h"
          },
          uirevision: true,
          hovermode:'closest',
          title: "",
          plot_bgcolor: 'rgba(0,0,0,0)',
          paper_bgcolor: 'rgba(0,0,0,0)',
          autoscale: false,
          autosize: false,
          margin: {
            l: 0,
            r: 0,
            pad: 4
          },
          x0: 0,
          y0: 12.0,
          x1: 1,
          y1: 12.0,
          font: {
            color: 'white',
            size: 12,
          },
          xaxis: {
            title: '',
            showgrid: false,
            zeroline: false,
            range: [],
            rangemode:'tozero',
            autorange:true,
            linecolor: 'rgba(0,0,0,0)',
            linewidth: 10,
            tickformat: '%H:%M\n%d.%m.%Y',
            nticks: 5,
            tickmode: 'auto',
            tickfont: {
              size: 12
            },
            type: 'date'
          },
          yaxis: {
            title: '',
            showgrid: false,
            showline: false,
            range: [0, 35],
            autorange:true,
            automargin: true,
            //tickformat: d3.format(".2f"),
            nticks: 12,
            tickmode: 'auto',
            tickfont: {
              size: 12
            }
          }
        },
        descriptor: null
      }
    },
    components:{
      Plotly
    },
    computed:{
      ...mapGetters(['getSubjectCreationDatas', 'getDeviceTypes', 'getSubDeviceTypes', 'getSelectedDevice']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    async mounted(){
      this.$root.$on('showChart', async (dv) => {
        this.dateChart.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        this.selectedDevice = dv
        await this.loadDeviceSensors()
        console.log(this.layout)
        console.log(this.data)
        //PlotlyJS.newPlot(this.$refs.plotlyChart, this.data, this.layout, {responsive: true} );
      })
    },
    methods:{
      ...mapActions(['getDeviceSensors', 'getDataForChart']),
      async updateParam(data){
        await this.loadCharts()
      },
      hideChart(){
        this.cleanChart()
        this.$emit('hideChart')
      },
      async loadCharts(){
        this.data = []
        let stDate = new Date(`${this.dateChart.date}T00:00`)
        let etDate = new Date(`${this.dateChart.date}T23:59`)
        this.layout.yaxis.range = [0, 0]
        this.layout.xaxis.range = [stDate, etDate]
        this.$root.$emit('loading', "start")
        await this.getDataForChart({
          Date: stDate.toISOString(),
          SubjectId: this.device.id,
          SensorTypeId: this.selectedSensorType
        })
        .then(async result => {
          console.log(result)
          this.$root.$emit('loading', "end")
          this.descriptor = result.sensorsDataDtos[0].measure.value
          const dateInfo = {
            name: result.sensorsDataDtos[0].measure.name,
            rawData: []
          }
          await result.sensorsDataDtos
          .filter(sens => {
            const d = new Date(sens.dateTime)
            return d >= stDate && d <= etDate
          })
          .forEach((sens) => {
            dateInfo.rawData.push({
              date: sens.dateTime,
              state: sens.state.replace(',', '.')
            })
          })
        console.log('chartSingleUpdate')
        //let dq = new Date(`${this.dateChart.date}T00:00`)
        //let dt = new Date(`${this.dateChart.date}T23:59`)
        let maxState = 0
        let minState = parseFloat(dateInfo.rawData[0].state)
        dateInfo.rawData.forEach(element => {
          if(parseFloat(element.state) > maxState){
            maxState = parseFloat(element.state)
          }
          if(parseFloat(element.state) < minState){
            minState = parseFloat(element.state)
          }
        });
        /*this.layout.xaxis.range = [dq.toJSON().substr(0,10), dt.toJSON().substr(0,10)]
        console.log(this.layout.xaxis.range)*/
        this.layout.xaxis.range = [stDate, etDate]
        this.layout.yaxis.range = [minState, maxState]

        this.data.push({
          type: 'scattergl',
          x: dateInfo.rawData.map(da => da.date),
          y: dateInfo.rawData.map(da => da.state),
          name: dateInfo.name,
          mode: 'lines+markers',
          line: {
            width: 3,
            shape: 'spline',
            color: 'rgba(0, 0, 0, 0)',
          },
          fillcolor: 'rgba(17, 157, 255, 0.1)',
          marker: {
            color: '#FFF',
            size: 3
          },
          hovertemplate: `<b>Object</b>: ${this.device.name}<br><b>Sensor</b>: ${dateInfo.name}<br><b>Date</b>: %{x|%d.%m.%Y}<br><b>Time</b>: %{x}<br><b>State</b>: %{y}` + this.descriptor + '<extra></extra>',
          hoverlabel: {
            bgcolor: 'rgba(0, 0, 255, 0.75)',
            opacity: 0,
            bordercolor: 'rgba(0,0,0,0)',
            namelength: "",
            font:{
              color: 'white'
            } 
          }
        })
        let ds = new Date()
        dateInfo.rawData.forEach(da => {
          let dt = new Date(da.date)
          this.data[0].x.push(dt)
          this.data[0].y.push(da.state)
        })
        //PlotlyJS.purge();
        console.log(this.layout)
        console.log(this.data)
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.description)
          this.$root.$emit('loading', "end")
        })
      },
      cleanChart(){
        this.data = []
      },
      async loadDeviceSensors(){
        this.$root.$emit('loading', "start")
        await this.getDeviceSensors(this.selectedDevice.id)
        .then(result => {
          //console.log(result)
          if(result.result.code == 0){
            this.selectedDeviceSensors = result.sensorTypesDtos
          }
          this.$root.$emit('loading', "end")
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
        })
      }
    }
  }
</script>
<style>
.overflow-hidden{
  overflow-x:hidden;
}
.v-picker__title__btn{
  color: black;
}
.modebar-container{
  display: none !important;
}
.js-plotly-plot .plot-container .svg-container{
  /*width: 400px !important;
  height: 200px !important;*/
}
</style>